import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { X } from "@phosphor-icons/react";

const STORAGE_KEY = "sws_announce_dismissed_v1";

/**
 * Slim promo bar shown at the very top of every public page. Links to /legacy.
 * Dismissible; dismissal persists for the browsing session only (sessionStorage).
 * Hidden entirely on /legacy so we don't nag the visitor once they arrive.
 */
export default function AnnouncementBar() {
  const location = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (location.pathname === "/legacy") {
      setVisible(false);
      return;
    }
    try {
      const dismissed = sessionStorage.getItem(STORAGE_KEY) === "1";
      setVisible(!dismissed);
    } catch {
      setVisible(true);
    }
  }, [location.pathname]);

  if (!visible) return null;

  const dismiss = (e) => {
    e.preventDefault();
    e.stopPropagation();
    try { sessionStorage.setItem(STORAGE_KEY, "1"); } catch { /* ignore */ }
    setVisible(false);
  };

  return (
    <a
      href="/legacy"
      data-testid="announcement-bar"
      className="relative block bg-[#B32027] text-white text-center py-2 px-10 text-[11px] sm:text-xs font-bold uppercase tracking-[0.2em] hover:bg-[#D42730] transition-colors"
    >
      <span>Year 1 is complete — see everything we accomplished →</span>
      <button
        type="button"
        onClick={dismiss}
        data-testid="announcement-bar-close"
        aria-label="Dismiss announcement"
        className="absolute right-2 top-1/2 -translate-y-1/2 inline-flex items-center justify-center w-7 h-7 hover:bg-white/15 transition-colors"
      >
        <X size={14} weight="bold" />
      </button>
    </a>
  );
}
